var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [
          _vm._v(_vm._s(_vm.$t("message.sts")) + " " + _vm._s(_vm.form.codigo))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "layout__main" }, [
      _c("div", { staticClass: "layout__main-form" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card__content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                _c("div", { staticClass: "select-field" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.tipo,
                          expression: "form.tipo"
                        }
                      ],
                      attrs: { disabled: !_vm.editable, id: "tipo" },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.form,
                              "tipo",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          _vm.cambiarTipo
                        ]
                      }
                    },
                    [
                      _c("option", { attrs: { value: "C" } }, [
                        _vm._v(_vm._s(_vm.$t("message.caja")))
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "M" } }, [
                        _vm._v(_vm._s(_vm.$t("message.maquina")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "tipo" } }, [
                    _vm._v(_vm._s(_vm.$t("message.tipo")))
                  ]),
                  _vm._v(" "),
                  _vm.errores.tipo
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [_c("strong", [_vm._v(_vm._s(_vm.errores.tipo[0]))])]
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: { id: "codigo", placeholder: "##" },
                        model: {
                          value: _vm.form.codigo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "codigo", $$v)
                          },
                          expression: "form.codigo"
                        }
                      },
                      [
                        _c("span", [_vm._v(_vm._s(_vm.$t("message.codigo")))]),
                        _vm._v(" "),
                        _vm.errores.codigo
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.codigo[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                _c("p", [
                  _c("label", { attrs: { for: "todasLineas" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.todasLineas,
                          expression: "todasLineas"
                        }
                      ],
                      attrs: { type: "checkbox", id: "todasLineas" },
                      domProps: {
                        checked: Array.isArray(_vm.todasLineas)
                          ? _vm._i(_vm.todasLineas, null) > -1
                          : _vm.todasLineas
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.todasLineas,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.todasLineas = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.todasLineas = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.todasLineas = $$c
                            }
                          },
                          _vm.changeTodasLineas
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("message.todasLineas")))])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.todasLineas,
                      expression: "!todasLineas"
                    }
                  ],
                  staticClass: "col-xs-12 col-md-6"
                },
                [
                  _c("div", { staticClass: "form-field select2" }, [
                    _c(
                      "div",
                      { staticClass: "select2-field" },
                      [
                        _c("v-select", {
                          attrs: {
                            label: "nombre",
                            options: _vm.lineas,
                            id: "linea",
                            placeholder: "Seleccione..."
                          },
                          on: { input: _vm.inputLinea },
                          model: {
                            value: _vm.form.selectedLinea,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "selectedLinea", $$v)
                            },
                            expression: "form.selectedLinea"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "linea" } }, [
                          _vm._v(_vm._s(_vm.$t("message.linea")))
                        ])
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                _c("div", { staticClass: "form-field select2" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "div",
                      { staticClass: "select2-field" },
                      [
                        _c("v-select", {
                          attrs: {
                            multiple: "",
                            id: "types",
                            options: _vm.types
                          },
                          model: {
                            value: _vm.form.types,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "types", $$v)
                            },
                            expression: "form.types"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "types" } }, [
                          _vm._v(_vm._s(_vm.$t("message.tipoContenedor")))
                        ]),
                        _vm._v(" "),
                        _vm.errores.types
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.types[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "chkTiposContenedor" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.todos_tipos_contenedor,
                            expression: "todos_tipos_contenedor"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          name: "chkTiposContenedor",
                          id: "chkTiposContenedor"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.todos_tipos_contenedor)
                            ? _vm._i(_vm.todos_tipos_contenedor, null) > -1
                            : _vm.todos_tipos_contenedor
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = _vm.todos_tipos_contenedor,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.todos_tipos_contenedor = $$a.concat([
                                      $$v
                                    ]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.todos_tipos_contenedor = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.todos_tipos_contenedor = $$c
                              }
                            },
                            _vm.changeTiposContenedor
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Todos")])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: { id: "descripcion" },
                        model: {
                          value: _vm.form.descripcion,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "descripcion", $$v)
                          },
                          expression: "form.descripcion"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("message.descripcion")))
                        ]),
                        _vm._v(" "),
                        _vm.errores.descripcion
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.descripcion[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: { id: "abrev" },
                        model: {
                          value: _vm.form.abrev,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "abrev", $$v)
                          },
                          expression: "form.abrev"
                        }
                      },
                      [
                        _c("span", [_vm._v("Abrev.")]),
                        _vm._v(" "),
                        _vm.errores.abrev
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.abrev[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                _c("div", { staticClass: "form-field select2" }, [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          options: _vm.tiposUnidad,
                          label: "codigo",
                          id: "tipoUnidad"
                        },
                        on: { input: _vm.inputTipoUnidad },
                        model: {
                          value: _vm.selectedTipoUnidad,
                          callback: function($$v) {
                            _vm.selectedTipoUnidad = $$v
                          },
                          expression: "selectedTipoUnidad"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "tipoUnidad" } }, [
                        _vm._v(_vm._s(_vm.$t("message.tipo_unidad")))
                      ])
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                _c("div", { staticClass: "form-field select" }, [
                  _c("div", { staticClass: "select-field" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.sts_type,
                            expression: "form.sts_type"
                          }
                        ],
                        attrs: { name: "sts_type", id: "sts_type" },
                        on: {
                          input: _vm.inputValoracion,
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.form,
                              "sts_type",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _vm.form.tipo !== "M"
                          ? _c("option", { attrs: { value: "PAR" } }, [
                              _vm._v(_vm._s(_vm.$t("message.parche")))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "POR" } }, [
                          _vm._v(_vm._s(_vm.$t("message.porcentaje")))
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "CON" } }, [
                          _vm._v(_vm._s(_vm.$t("message.constante")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "sts_type" } }, [
                      _vm._v(_vm._s(_vm.$t("message.tipoValoracion")))
                    ]),
                    _vm._v(" "),
                    _vm.errores.sts_type
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.errores.sts_type[0]))
                            ])
                          ]
                        )
                      : _vm._e()
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          vMoney: "",
                          format: _vm.decimal,
                          id: "horas_hombre"
                        },
                        model: {
                          value: _vm.form.horas_hombre,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "horas_hombre", $$v)
                          },
                          expression: "form.horas_hombre"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("message.horas_hombre")))
                        ]),
                        _vm._v(" "),
                        _vm.errores.horas_hombre
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.horas_hombre[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.form.selectedLinea !== null &&
                        _vm.form.selectedLinea.code === "MSK"
                          ? true
                          : false,
                      expression:
                        "form.selectedLinea !== null && form.selectedLinea.code === 'MSK'?true:false"
                    }
                  ],
                  staticClass: "col-xs-12 col-md-6"
                },
                [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: { id: "siglas" },
                          model: {
                            value: _vm.form.siglas,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "siglas", $$v)
                            },
                            expression: "form.siglas"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("message.siglasComa")))
                          ]),
                          _vm._v(" "),
                          _vm.errores.siglas
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.siglas[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.tipo === "M",
                      expression: "form.tipo === 'M'"
                    }
                  ],
                  staticClass: "col-xs-12 col-md-6"
                },
                [
                  _c("div", { staticClass: "form-field select2" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              id: "modelosMaquina",
                              multiple: "",
                              options: _vm.tiposModelo
                            },
                            model: {
                              value: _vm.form.tipos_modelo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "tipos_modelo", $$v)
                              },
                              expression: "form.tipos_modelo"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "modelosMaquina" } }, [
                            _vm._v(_vm._s(_vm.$t("message.tiposModelo")))
                          ]),
                          _vm._v(" "),
                          _vm.errores.tipos_modelo
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.tipos_modelo[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "chkModelosMaquina" } }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.todos_modelos_maquina,
                              expression: "todos_modelos_maquina"
                            }
                          ],
                          attrs: {
                            type: "checkbox",
                            name: "chkModelosMaquina",
                            id: "chkModelosMaquina"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.todos_modelos_maquina)
                              ? _vm._i(_vm.todos_modelos_maquina, null) > -1
                              : _vm.todos_modelos_maquina
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = _vm.todos_modelos_maquina,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.todos_modelos_maquina = $$a.concat([
                                        $$v
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.todos_modelos_maquina = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.todos_modelos_maquina = $$c
                                }
                              },
                              _vm.changeModelosMaquina
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Todos")])
                      ])
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.sts_type === "CON",
                      expression: "form.sts_type === 'CON'"
                    }
                  ],
                  staticClass: "col-xs-12 col-md-6"
                },
                [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            vMoney: "",
                            format: _vm.money,
                            id: "valor",
                            placeholder: "##.##"
                          },
                          model: {
                            value: _vm.form.valor,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "valor", $$v)
                            },
                            expression: "form.valor"
                          }
                        },
                        [
                          _c("span", [_vm._v(_vm._s(_vm.$t("message.valor")))]),
                          _vm._v(" "),
                          _vm.errores.valor
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.valor[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          vMoney: "",
                          format: _vm.decimal,
                          id: "valor",
                          placeholder: "##.##"
                        },
                        model: {
                          value: _vm.form.maximo_piezas,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "maximo_piezas", $$v)
                          },
                          expression: "form.maximo_piezas"
                        }
                      },
                      [
                        _c("span", [_vm._v(_vm._s(_vm.$t("message.piezas")))]),
                        _vm._v(" "),
                        _vm.errores.maximo_piezas
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.maximo_piezas[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.tipo === "M",
                      expression: "form.tipo === 'M'"
                    }
                  ],
                  staticClass: "col-xs-12 col-md-6"
                },
                [
                  _c("div", { staticClass: "form-field select2" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              id: "tipo_maquina",
                              multiple: "",
                              options: _vm.tiposMaquina
                            },
                            model: {
                              value: _vm.form.tipos_maquina,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "tipos_maquina", $$v)
                              },
                              expression: "form.tipos_maquina"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "tipo_maquina" } }, [
                            _vm._v(_vm._s(_vm.$t("message.tipos")))
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "chkTiposMaquina" } }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.todos_tipos_maquina,
                              expression: "todos_tipos_maquina"
                            }
                          ],
                          attrs: {
                            type: "checkbox",
                            name: "chkTiposMaquina",
                            id: "chkTiposMaquina"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.todos_tipos_maquina)
                              ? _vm._i(_vm.todos_tipos_maquina, null) > -1
                              : _vm.todos_tipos_maquina
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = _vm.todos_tipos_maquina,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.todos_tipos_maquina = $$a.concat([
                                        $$v
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.todos_tipos_maquina = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.todos_tipos_maquina = $$c
                                }
                              },
                              _vm.changeTiposMaquina
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Todos")])
                      ])
                    ])
                  ])
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-3" }, [
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card__title" }, [
                _c("h5", [_vm._v(_vm._s(_vm.$t("message.damages")))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card__content" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12" },
                    [
                      _c("checked-listbox", {
                        attrs: {
                          label: "nombre",
                          items: _vm.damages,
                          name: "damages[]"
                        },
                        on: { input: _vm.inputDamages },
                        model: {
                          value: _vm.form.damages,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "damages", $$v)
                          },
                          expression: "form.damages"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.tipo === "M",
                    expression: "form.tipo === 'M'"
                  }
                ],
                staticClass: "card mt-3"
              },
              [
                _c("div", { staticClass: "card__title" }, [
                  _c("h5", [_vm._v(_vm._s(_vm.$t("message.partes")))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card__content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12" },
                      [
                        _c("checked-listbox", {
                          attrs: {
                            label: "nombre",
                            items: _vm.materiales,
                            name: "materiales[]"
                          },
                          on: { input: _vm.inputMateriales },
                          model: {
                            value: _vm.form.materiales,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "materiales", $$v)
                            },
                            expression: "form.materiales"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card__title" }, [
                _c("h5", [_vm._v(_vm._s(_vm.$t("message.modos")))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card__content" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12" },
                    [
                      _c("checked-listbox", {
                        attrs: {
                          label: "nombre",
                          items: _vm.modos,
                          name: "modos[]"
                        },
                        on: { input: _vm.inputModos },
                        model: {
                          value: _vm.form.modos,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "modos", $$v)
                          },
                          expression: "form.modos"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.sts_type !== "CON",
                    expression: "form.sts_type !== 'CON'"
                  }
                ],
                staticClass: "card mt-3"
              },
              [
                _c("div", { staticClass: "card__title" }, [
                  _c("h5", [_vm._v(_vm._s(_vm.$t("message.valoracionArea")))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card__content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12" },
                      [
                        _c("tabla-areas", {
                          attrs: { sts_type: _vm.form.sts_type },
                          model: {
                            value: _vm.form.areas,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "areas", $$v)
                            },
                            expression: "form.areas"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layout__main-buttons" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card__content" }, [
            _c(
              "button",
              {
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: { click: _vm.aceptar }
              },
              [
                _c("i", { staticClass: "fa fa-save" }),
                _c("span", [_vm._v(_vm._s(_vm.$t("message.guardar")))])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-secondary btn--text",
                attrs: { type: "button" },
                on: { click: _vm.nuevo }
              },
              [
                _c("i", { staticClass: "fa fa-plus" }),
                _c("span", [_vm._v(_vm._s(_vm.$t("message.nuevo")))])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.estado !== "N",
                    expression: "form.estado !== 'N'"
                  }
                ],
                staticClass: "btn--text",
                class: {
                  "btn-danger": _vm.form.estado === "A",
                  "btn-success": _vm.form.estado === "I"
                },
                attrs: { type: "button" },
                on: { click: _vm.eliminar }
              },
              [
                _c("i", { staticClass: "fa fa-ban" }),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.form.estado === "A"
                        ? _vm.$t("message.desactivar2")
                        : _vm.$t("message.activar2")
                    )
                  )
                ])
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-996ab064", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-996ab064","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/sts/Sts.vue
// module id = 385
// module chunks = 0